import axios from "axios";
import _ from "lodash";

export default {
    data() {
        return {
            isCollective: false,
            selected: [],
            pp: [],
            mode: String,
            collectiveLoading: false
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        onCollective() {
            this.collectiveLoading = true;
            this.fetch().then(res => {
                this.collectiveLoading = false;
                this.isCollective = true;
                // this.EnCommission = true;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                    this.formCollective.setFieldsValue({
                        iscommision: "1",
                        without_note: "0",
                    });
                });
            }).catch(err => {
                this.displayMessageValue("basic-error", 'Please select No. PP!')
                this.collectiveLoading = false;
            });
        },
        handleCloseCollective() {
            Event.$emit("fetchPp", 0);
            this.isCollective = false;
            this.reset();
        },
        handleCheck(e) {
            const item = {
                id_klaim: e.target.value.id_klaim_draft,
                id: e.target.value.id,
                kredit: e.target.value.kredit
            };
            this.selected.filter(obj => obj.id == item.id).length == 0 ? this.selected.push(item) : this.selected.splice(this.selected.findIndex(obj => obj.id == item.id), 1)
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handlePp(e) {
            this.selectedPp = this.ppDetail.filter(
                (obj) => obj.id_pp_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
        },
        async fetch() {
            await axios({
                method: "get",
                url: this.$serviceUrl + "klaim_cc_pp/pp_detil",
                params: this.mode=='Create' ? {
                    id_pp: this.collectData.informasi.id_pp,
                    id_klaim_draft: this.id_klaim,
                } : {
                    id_pp: this.collectData.informasi.id_pp,
                },
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password,
                },
                headers: {
                    "X-API-KEY": this.getAuth.apikey,
                },
            })
                .then((response) => {
                    this.pp = response.data.list_nama_item;
                })
                .catch((err) => {
                    return err.response.data.message
                });
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.displayMessage("form-warning");
                    return;
                }

                axios({
                    method: "put",
                    url: this.type == 'revised' ? this.$serviceUrl + "klaim_cc_pp/revisi_detil_pemakaian_kolektif" : this.$serviceUrl + "klaim_cc_pp/detil_pemakaian_kolektif",
                    processData: false,
                    data: {
                        "id_klaim": this.id_klaim,
                        "id_pp_dtl": values.id_pp_dtl,
                        "selected_item": this.selected,
                        "iscommision": values.iscommision,
                        "without_note": "1"
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(res => {
                    this.fetch();
                    this.fetchPemakaian();
                    this.reset();
                    // this.EnCommission = true;
                    this.Viwithout_note = true;
                    this.$nextTick(function () {
                        this.formCollective.setFieldsValue({
                            iscommision: "1",
                            without_note: "0",
                        });
                    });
                    this.displayMessage("success-save");
                }).catch(err => {
                    this.displayMessageValue("basic-error", err.response.data.message);
                })
            })
        },
        reset() {
            this.formCollective.resetFields();
            this.selected = [];
        },
        handleChangeumDtl(val){
            let selectedumDtl = _.filter(this.pp, { id_pp_dtl: val });
            if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
                // this.EnCommission = true;
                this.Viwithout_note = false;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
            }else{
                // this.EnCommission = false;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "0",
                    without_note: "0",
                });
                });
            }
        },
    }
}